import React from 'react';

import { render } from 'react-dom';
import { IoClose } from 'react-icons/io5';
import * as cn from 'classnames';

import { Text, Button } from 'modules/common';

import Loader from './Loader';
import { renderColors } from './constants';

const toastUniqueID = 'geek-toast-marker';

const AlertMarker = (props) => <div id={`${toastUniqueID}-alert`} {...props} />;

let toastTimeout = null;

const wait = (t) => new Promise((r) => setTimeout(r, t));

const toast = async (content, options = {}) => {
  let alertRef = null;
  const opt = {
    timeout: 4000,
    title: false,
    divId: 'alert-override',
    position: 'top-right',
    type: 'default',
    withTimer: false,
    withButton: false,
    withClose: true,
    buttonProps: {},
    ...options,
    content,
  };

  const isInline = !!document.getElementById(opt.divId);
  const rootElement =
    document.getElementById(opt.divId) ||
    document.getElementById(`${toastUniqueID}-alert`);

  if (!rootElement) {
    alert('Alert Marker not found!'); // eslint-disable-line
    return;
  }

  const close = async () => {
    if (alertRef) {
      try {
        // await wait(450);
        alertRef.className = alertRef.className.replace(
          'alert-entrance-ds',
          'alert-exit-ds'
        );
        await wait(450);
      } catch (error) {
        // do nothing...
      }
    }

    document.body.className = '';
    render(<AlertMarker />, rootElement);
  };
  close();
  await wait(5);
  const renderContent = () => {
    if (typeof opt.content === 'function') return opt.content(close);
    return opt.content;
  };

  const style = {
    text: renderColors?.[opt?.type]?.text,
    buttonProps: renderColors?.[opt?.type]?.buttonProps,
  };

  const renderAlert = () => (
    <div className="h-full bg-light border border-default rounded">
      <div className={cn('flex relative p-ds-16 space-x-3 items-start')}>
        <div className="flex-shrink-0">
          <svg
            className={cn('h-[18px] w-[18px]', style.text)}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clipRule="evenodd"
            />
          </svg>
        </div>

        <div className="flex flex-col gap-ds-12 flex-1 -mt-px">
          {(Boolean(opt?.title) || Boolean(opt.content)) && (
            <div className="flex flex-col gap-ds-4">
              {Boolean(opt?.title) && (
                <Text weight="semibold" color="primitive-black">
                  {opt?.title}
                </Text>
              )}

              {Boolean(opt.content) && (
                <Text type="caption" color="muted">
                  {renderContent()}
                </Text>
              )}
            </div>
          )}

          {opt?.withButton && (
            <div className="-ml-1">
              <Button
                {...opt?.buttonProps}
                className={cn(opt?.buttonProps?.className)}
                variant="text"
                size="xs"
                {...style.buttonProps}
              />
            </div>
          )}
        </div>

        {opt?.withClose && (
          <div
            className={cn(
              'flex gap-ds-8',
              !opt.content || !opt.title
                ? 'flex-row-reverse items-center'
                : 'flex-col items-end'
            )}
          >
            <div>
              <span
                role="presentation"
                className="cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  close();
                }}
              >
                <IoClose className="h-4 w-4 text-muted" />
              </span>
            </div>
          </div>
        )}
      </div>
      <Loader
        type={opt?.type}
        timer={opt?.timeout}
        withTimer={opt?.withTimer}
      />
    </div>
  );

  if (opt?.withTimer) {
    clearTimeout(toastTimeout);
    toastTimeout = setTimeout(() => {
      close();
    }, opt.timeout);
  }

  if (isInline) {
    render(renderAlert(), rootElement);
    return;
  }

  render(
    <div className={`z-50 fixed xs:w-72 w-80 md:w-96 m-h-20 ${opt?.position}`}>
      <div
        // eslint-disable-next-line no-return-assign
        ref={(r) => (alertRef = r)}
        className="shadow-tooltip h-full w-full rounded overflow-hidden alert-entrance-ds"
      >
        {renderAlert()}
      </div>
    </div>,
    rootElement
  );
};

export default AlertMarker;

export const showAlert = (content, options) => toast(content, options);
